import { FC } from 'react';

interface DegreeVideoProps {
  url: string;
}

export const DegreeVideo: FC<DegreeVideoProps> = ({ url }) => {
  const getYouTubeEmbedUrl = (url: string): string | null => {
    const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/;
    const match = url.match(youtubeRegex);

    return match ? `https://www.youtube.com/embed/${match[1]}?rel=0` : null;
  };

  const isYouTubeUrl = url.includes('youtube.com') || url.includes('youtu.be');
  const embedUrl = isYouTubeUrl ? getYouTubeEmbedUrl(url) : null;

  if (!embedUrl) {
    return null;
  }

  return (
    <div className="relative w-full aspect-video overflow-hidden rounded-3xl">
      <iframe
        src={embedUrl}
        className="absolute inset-0 h-full w-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Newlane Associate of Arts Degree Introduction"
      />
    </div>
  );
};
